module.exports = __webpack_public_path__ + "img/Ziro Festival of Music.d8d0444b.jpg";